import React from 'react'
import EditForm from '../edit-form'
import Modal from '../../modals/wrapper'

const DetailsModal = ({
    resourceId,
    onHide = () => {}
}) => {
   
    return (
        <Modal
            size='lg'
            backdrop='static'
        >
            <EditForm resourceId={resourceId} onComplete={onHide} />
        </Modal>
    )
}

export default DetailsModal